<template>
  <vs-table-mod :data="summary"
                :max-items="tableConfig.maxItemsPerPage"
                pagination
                search>
    <template slot="thead">
      <vs-th>{{ $t('zoom-import.summary-student-code') }}</vs-th>
      <vs-th>{{ $t('zoom-import.summary-name') }}</vs-th>
      <vs-th>{{ $t('zoom-import.summary-session-count') }}</vs-th>
      <vs-th>{{ $t('zoom-import.summary-total-time') }}</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
        <vs-td :data="tr.studentCode">
          <span :class="tr.studentCode ? '' : 'text-warning'">
            {{ tr.studentCode || $t('zoom-import.summary-no-code') }}
          </span>
        </vs-td>
        <vs-td :data="tr.names[0]">
          <div v-for="(name, indexname) in tr.names" :key="indexname">{{ name }}</div>
        </vs-td>
        <vs-td :data="tr.sessionCount">{{ tr.sessionCount }}</vs-td>
        <vs-td :data="tr.totalDuration">{{ tr.totalDuration }}</vs-td>
      </vs-tr>
    </template>
  </vs-table-mod>
</template>

<script>
import {tableConfig} from '@/utils/table';

/**
 * Renders the per-student summary produced by summarizeByStudent() in
 * @/utils/zoom-cdr. Presentational only -- no state, no store, no events --
 * so the three screens that import a Zoom CDR can share one table instead of
 * carrying three copies of this markup.
 *
 * It deliberately does NOT hide itself when `summary` is empty: it lives in a
 * tab, and a tab that appears and disappears makes the tab strip jump.
 */
export default {
  name: 'ZoomSummaryTable',
  components: {
    vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
  },
  props: {
    summary: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      tableConfig: tableConfig,
    };
  },
};
</script>
